import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, MapPin, Building, User, Calendar, Eye } from "lucide-react";
import StatusBadge from "./StatusBadge";
import { Button } from "../../components/AdminSharedComponents";

// ===============================
// CONSTANTS
// ===============================
const PROJECT_DETAIL_ITEMS = [
  {
    key: "location",
    icon: MapPin,
    label: "Location",
    getValue: (project) => project.location || "No location specified",
    condition: () => true,
  },
  {
    key: "client_name",
    icon: Building,
    label: "Client",
    getValue: (project) => project.client_name,
    condition: (project) => !!project.client_name,
  },
  {
    key: "pic",
    icon: User,
    label: "PIC (Person In Charge)",
    getValue: (project) => project.pic,
    condition: (project) => !!project.pic,
  },
  {
    key: "created_at",
    icon: Calendar,
    label: "Created",
    getValue: (project, formatDate) => formatDate(project.created_at),
    condition: () => true,
  },
];

// ===============================
// COMPONENT
// ===============================
const ProjectDetail = ({ project, onBack, formatDate }) => {
  return (
    <div className="h-full flex flex-col">
      {/* Header */}
      <div className="p-4 border-b border-gray-200">
        <div className="flex items-center gap-3 mb-2">
          <Button variant="secondary" size="sm" onClick={onBack}>
            <ArrowLeft className="h-4 w-4" />
          </Button>
          <h2 className="text-lg font-semibold text-primary-dark">
            Project Details
          </h2>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto p-4">
        <div className="space-y-4">
          {/* Project Title */}
          <div>
            <h3 className="text-xl font-bold text-primary-dark mb-2">
              {project.name}
            </h3>
            <StatusBadge status={project.status} />
          </div>

          {/* Project Information */}
          <div className="space-y-3">
            {PROJECT_DETAIL_ITEMS.map(
              ({ key, icon: Icon, label, getValue, condition }) =>
                condition(project) ? (
                  <div key={key} className="flex items-start gap-3">
                    <Icon className="h-4 w-4 text-gray-400 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="text-sm font-medium text-gray-900">
                        {label}
                      </div>
                      <div className="text-sm text-gray-600">
                        {getValue(project, formatDate)}
                      </div>
                    </div>
                  </div>
                ) : null
            )}
          </div>

          {/* Action Button */}
          <div className="pt-4 border-t border-gray-200">
            <Link to={`/admin/projects/show/${project.id}`}>
              <Button className="w-full">
                <Eye className="h-4 w-4 mr-2" />
                View Full Project Details
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetail;
